import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTenant, GetOrder, checkSession } from './module';

const initialState = {
    orderList: null,
    activePage: 1,
    tenantList: null,
    filter: {
        PageSize: 10,
        PageNumber: 1,
        FromDate: null,
        ToDate: null,
        PublishStatus: null,
        TenantId: null
    },
    mySession: null,
    status: "idle",
    ActionStatus: "",
    errorMessage: ""
};

export const checkSessionAsync = createAsyncThunk(
    'requests/checkSession',
    async (index, ThunkAPI) => {
        const response = await checkSession();
        return response;
    }
);

export const GetOrderAsync = createAsyncThunk(
    'requests/GetOrder',
    async (data, ThunkAPI) => {
        // data.AttachmentChecking=false;
        const response = await GetOrder({...data, AttachmentChecking: false});
        return response;
    }
);

export const getTenantAsync = createAsyncThunk(
    'requests/getTenant',
    async (data, ThunkAPI) => {
        const response = await getTenant();
        // const resultPromise = Promise.resolve(response);
        // resultPromise.then((tenant, index) => {
        //     var result = {
        //         PageSize: 10,
        //         PageNumber: 1,
        //         TenantId: tenant.Tenants ? tenant.Tenants[0].TenantId : ''
        //     }
        //     setTimeout(() => {
        //         ThunkAPI.dispatch(GetOrderAsync(result));
        //     }, 100);

        // })
        return response;
    }
);

export const requestsSlice = createSlice({
    name: 'requests',
    initialState,
    reducers: {
        updateActivePage: (state, action) => {
            var result = state.filter;
            result.PageNumber = action.payload
            state.activePage = action.payload;
        },
        filterOrder: (state, action) => {
            var result = state.filter;
            var data = action.payload;

            switch (data.name) {
                case 'tenantFilter':
                    result.TenantId = data.value
                    break;
                case 'requestType':
                    result.PublishStatus = data.value
                    break;
                case 'startDate':
                    result.FromDate = data.value
                    break;
                case 'endDate':
                    result.ToDate = data.value
                    break;
                default:
                    break;
            }
            //state.filter = result;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(GetOrderAsync.pending, (state) => {
            // console.log("GetOrderAsync Setting status to loading")
            state.status = 'loading';
        });
        builder.addCase(GetOrderAsync.rejected, (state) => {
            // console.log("state",{state})
            state.status = 'rejected';
        });
        builder.addCase(GetOrderAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            // console.log("Done, setting status to idle")

            state.orderList = action.payload;

            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
        });
        builder.addCase(getTenantAsync.pending, (state) => {
            //state.status = 'loading';
        });
        builder.addCase(getTenantAsync.rejected, (state) => {
            //state.status = 'rejected';
        });
        builder.addCase(getTenantAsync.fulfilled, (state, action) => {
            //state.status = 'idle';
    
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }else{
                state.tenantList = action.payload.Tenants;
                // var result = state.filter;
                // result.TenantId = state.tenantList && state.tenantList.length > 0 ? state.tenantList[0].TenantId : '';
            }
        });
        builder.addCase(checkSessionAsync.pending, (state) => {
            // console.log("checkSessionAsync Setting status to loading")

            state.status = 'loading';
        });
        builder.addCase(checkSessionAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(checkSessionAsync.fulfilled, (state, action) => {
            // console.log("checkSessionAsync_ status should be idle")
            state.status = 'idle';
            
            if(action.payload && action.payload.Status !== 'OK'){
                window.location.href="./login";
            }
        });
    }
});

export const { updateActivePage, filterOrder } = requestsSlice.actions;
export const pagesState = (state) => state.requests;
export const mySession = (state) => state.Session.mySession;
export const paginationChanged = (pgNum) => (dispatch, getState) => {

    dispatch(updateActivePage(pgNum));
 
    setTimeout(() => {
        dispatch(GetOrderAsync(getState().requests.filter));
    }, 300);
    // dispatch(selectAllItems());
    // setTimeout(() => {
    //     var items = { CartItems: getState().cart.CartItems }
    //     dispatch(cartCalculation(items));
    // }, 100);
};

export default requestsSlice.reducer;
